export const FETCH_FAQ = "faq/fetch";
export const DELETE_FAQ = "faq/delete";
export const ADD_FAQ = "faq/add";
export const UPDATE_FAQ = "faq/update";
